export default {
  month_names: [
    "Januari",
    "Februari",
    "Mars",
    "April",
    "Maj",
    "Juni",
    "Juli",
    "Augusti",
    "September",
    "Oktober",
    "November",
    "December",
  ],
  month_names_short: [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "Maj",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Okt",
    "Nov",
    "Dec",
  ],
  day_names: [
    "Söndag",
    "Måndag",
    "Tisdag",
    "Onsdag",
    "Torsdag",
    "Fredag",
    "Lördag",
  ],
  day_names_short: ["Sön", "Mån", "Tis", "Ons", "Tor", "Fre", "Lör"],
  day_names_min: ["Sö", "Må", "Ti", "On", "To", "Fr", "Lö"],
  weekday_names: ["Måndag", "Tisdag", "Onsdag", "Torsdag", "Fredag"],

  get_time_from_minutes: function (minutes) {
    var hours = Math.floor(minutes / 60);
    minutes -= hours * 60;
    return Utils.addZero(hours) + ":" + Utils.addZero(minutes);
  },
  format_minutes_to_string: function (minutes) {
    var hours = Math.floor(minutes / 60);
    minutes -= hours * 60;
    var output = hours ? (output = hours + "h ") : "";
    if (minutes) output += minutes + "min";
    return output || "0 min";
  },
};
